import { render, staticRenderFns } from "./BlockListViewer.vue?vue&type=template&id=26a6070d&scoped=true&"
import script from "./BlockListViewer.vue?vue&type=script&lang=js&"
export * from "./BlockListViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a6070d",
  null
  
)

export default component.exports